'use strict';

const datesUtil = require('util/date');

// when changing options such as selectable days, call
// this.refreshUI() - it will update the date picker
// it's a hack: but necessary because we're mixing angular
// and jquery UI components. it's mildy expensive so don't
// do it too often!
function controller($scope, $timeout, plannerService) {
    const vm = this;

    vm.dates = {};

    vm.selectedRange = {
        start: null,
        end: null,
    }

    vm.isSingleDaySelected = true;

    plannerService.getPerformances().then(perfs => {

        const first = perfs.shift();
        let last = perfs.pop();
        
        // If we havent got an event then don't refresh the ui
        if (!first) {
            return false;
        }

        if(!last) {
            last = first;
        }

        vm.refreshUI({
            // numberOfMonths: (last.start_date_moment.format('YYYYMM') - first.start_date_moment.format('YYYYMM')) + 1,
            minDate: first.start_date_moment.toDate(),
            maxDate: last.start_date_moment.toDate(),
        });
    });

    // refreshes the datepicker UI
    // options:
    //   numberOfMonths: how many seperate month calendars to display
    vm.refreshUI = function(options) {
        if ($scope.refresh) {
            $scope.refresh(options);
        }
    }
    vm.changeSelection = function(range) {

        if (range.start && range.end) {
            $timeout(() => {
                vm.selectedRange = range;
                vm.isSingleDaySelected = vm.selectedRange.start.isSame(vm.selectedRange.end);
            });
        } else {
            $timeout(() => {
                vm.selectedRange = {
                    start: null,
                    end: null,
                }
                vm.isSingleDaySelected = false;
            });
        }
    }
}

module.exports = [
    '$scope',
    '$timeout',
    'plannerService',
    controller
];



// WEBPACK FOOTER //
// ./widgets/controllers/Calendar.js